import CombinedPreferencesWindow from './CombinedPreferencesWindow'

export default CombinedPreferencesWindow